window.addEventListener('DOMContentLoaded', () => {
  gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

  initNav();

  const heroIframe = document.querySelector('.hero__media iframe');
  if (heroIframe) {
    heroIframe.addEventListener('load', () => {
      setTimeout(() => heroIframe.classList.add('is-loaded'), 300);
    });
  }

  // Video modal (shared by film/Vimeo and chapter/YouTube)
  const videoModal    = document.getElementById('video-modal');
  const modalVideo    = videoModal?.querySelector('.video-modal__video');
  const modalClose    = videoModal?.querySelector('.video-modal__close');
  const modalBg       = videoModal?.querySelector('.video-modal__backdrop');
  const modalPlayBtn  = videoModal?.querySelector('.video-modal__play-btn');
  const modalProgress = videoModal?.querySelector('.video-modal__progress');
  const modalFill     = videoModal?.querySelector('.video-modal__progress-fill');
  const modalTime     = videoModal?.querySelector('.video-modal__time');

  let vimeoPlayer   = null;
  let videoDuration = 0;

  const formatTime = (s) => {
    const m = Math.floor(s / 60);
    return `${m}:${Math.floor(s % 60).toString().padStart(2, '0')}`;
  };

  if (videoModal) {
    const closeModal = () => {
      videoModal.classList.remove('is-open', 'is-youtube');
      videoModal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (vimeoPlayer) { vimeoPlayer.destroy(); vimeoPlayer = null; }
      setTimeout(() => { modalVideo.innerHTML = ''; }, 300);
      modalPlayBtn.dataset.state = 'paused';
      modalFill.style.width = '0%';
      modalTime.textContent = '0:00 / 0:00';
    };

    // Film section modal (YouTube or Vimeo)
    const filmTrigger = document.querySelector('[data-film-trigger]');
    if (filmTrigger) {
      const youtubeId   = filmTrigger.dataset.youtubeId;
      const filmSrc     = filmTrigger.querySelector('iframe')?.src || '';
      const vimeoMatch  = filmSrc.match(/vimeo\.com\/video\/(\d+)/);

      const openFilmModal = () => {
        const iframe = document.createElement('iframe');
        iframe.allow = 'autoplay; fullscreen; picture-in-picture';
        iframe.allowFullscreen = true;
        iframe.frameBorder = '0';
        modalVideo.innerHTML = '';
        modalVideo.appendChild(iframe);

        if (youtubeId) {
          iframe.src = `https://www.youtube.com/embed/${youtubeId}?autoplay=1&rel=0`;
          videoModal.classList.add('is-open', 'is-youtube');
        } else {
          if (!vimeoMatch) return;
          iframe.src = `https://player.vimeo.com/video/${vimeoMatch[1]}?autoplay=1&controls=0`;
          vimeoPlayer = new Vimeo.Player(iframe);
          vimeoPlayer.getDuration().then(d => { videoDuration = d; });
          vimeoPlayer.on('play',  () => { modalPlayBtn.dataset.state = 'playing'; modalPlayBtn.setAttribute('aria-label', 'Pause'); });
          vimeoPlayer.on('pause', () => { modalPlayBtn.dataset.state = 'paused';  modalPlayBtn.setAttribute('aria-label', 'Play'); });
          vimeoPlayer.on('ended', () => { modalPlayBtn.dataset.state = 'paused'; });
          vimeoPlayer.on('timeupdate', ({ seconds, duration }) => {
            if (duration) videoDuration = duration;
            modalFill.style.width = `${duration ? (seconds / duration) * 100 : 0}%`;
            modalTime.textContent = `${formatTime(seconds)} / ${formatTime(duration || 0)}`;
          });
          videoModal.classList.add('is-open');
        }

        videoModal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      };

      filmTrigger.addEventListener('click', openFilmModal);
      document.querySelector('.section-film .btn')?.addEventListener('click', (e) => {
        e.preventDefault();
        openFilmModal();
      });

      modalPlayBtn.addEventListener('click', () => {
        if (!vimeoPlayer) return;
        vimeoPlayer.getPaused().then(paused => paused ? vimeoPlayer.play() : vimeoPlayer.pause());
      });

      modalProgress.addEventListener('click', (e) => {
        if (!vimeoPlayer || !videoDuration) return;
        const rect = modalProgress.getBoundingClientRect();
        vimeoPlayer.setCurrentTime(((e.clientX - rect.left) / rect.width) * videoDuration);
      });
    }

    // YouTube modal — chapter sections (disabled: video_id kept in markup for future use)
    // const openYoutubeModal = (youtubeId) => {
    //   const iframe = document.createElement('iframe');
    //   iframe.src = `https://www.youtube.com/embed/${youtubeId}?autoplay=1&rel=0`;
    //   iframe.allow = 'autoplay; fullscreen; picture-in-picture';
    //   iframe.allowFullscreen = true;
    //   iframe.frameBorder = '0';
    //   modalVideo.innerHTML = '';
    //   modalVideo.appendChild(iframe);

    //   videoModal.classList.add('is-open', 'is-youtube');
    //   videoModal.setAttribute('aria-hidden', 'false');
    //   document.body.style.overflow = 'hidden';
    // };

    // document.querySelectorAll('[data-youtube-id]').forEach(trigger => {
    //   trigger.addEventListener('click', (e) => {
    //     e.preventDefault();
    //     openYoutubeModal(trigger.dataset.youtubeId);
    //   });
    // });

    // Shared close handlers
    modalClose.addEventListener('click', closeModal);
    modalBg.addEventListener('click', closeModal);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && videoModal.classList.contains('is-open')) closeModal();
    });
  }

  // Poem modal
  const poemModal = document.getElementById('poem-modal');
  if (poemModal) {
    const poemModalClose = poemModal.querySelector('.poem-modal__close');
    const poemModalBg    = poemModal.querySelector('.poem-modal__backdrop');

    const openPoemModal = () => {
      poemModal.classList.add('is-open');
      poemModal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    };

    const closePoemModal = () => {
      poemModal.classList.remove('is-open');
      poemModal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (poemAudio && !poemAudio.paused) {
        poemAudio.pause();
        poemAudio.currentTime = 0;
        poemModal.classList.remove('is-playing');
      }
    };

    // Audio player
    const poemAudio    = document.getElementById('poem-audio');
    const audioBtn     = document.getElementById('poem-audio-btn');
    const audioFill    = document.getElementById('poem-audio-fill');
    const audioProgress = document.getElementById('poem-audio-progress');
    const audioCurrent = document.getElementById('poem-audio-current');
    const audioDuration = document.getElementById('poem-audio-duration');

    const formatTime = (s) => {
      const m = Math.floor(s / 60);
      return m + ':' + String(Math.floor(s % 60)).padStart(2, '0');
    };

    if (poemAudio && audioBtn) {
      audioBtn.addEventListener('click', () => {
        if (poemAudio.paused) {
          poemAudio.play();
          poemModal.classList.add('is-playing');
        } else {
          poemAudio.pause();
          poemModal.classList.remove('is-playing');
        }
      });

      poemAudio.addEventListener('timeupdate', () => {
        if (!poemAudio.duration) return;
        const pct = (poemAudio.currentTime / poemAudio.duration) * 100;
        audioFill.style.width = pct + '%';
        audioCurrent.textContent = formatTime(poemAudio.currentTime);
        audioProgress.setAttribute('aria-valuenow', Math.round(pct));
      });

      poemAudio.addEventListener('loadedmetadata', () => {
        audioDuration.textContent = formatTime(poemAudio.duration);
      });

      poemAudio.addEventListener('ended', () => {
        poemModal.classList.remove('is-playing');
        audioFill.style.width = '0%';
        audioCurrent.textContent = '0:00';
      });

      audioProgress.addEventListener('click', (e) => {
        const rect = audioProgress.getBoundingClientRect();
        const pct = (e.clientX - rect.left) / rect.width;
        poemAudio.currentTime = pct * poemAudio.duration;
      });
    }

    document.querySelector('[data-poem-trigger]')?.addEventListener('click', openPoemModal);
    poemModalClose?.addEventListener('click', closePoemModal);
    poemModalBg?.addEventListener('click', closePoemModal);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && poemModal.classList.contains('is-open')) closePoemModal();
    });
  }

  // Hover-play videos in section-chapter (disabled: replaced by viewport autoplay)
  // document.querySelectorAll('.section-chapter__video-placeholder--hover-play').forEach(el => {
  //   const video = el.querySelector('video');
  //   if (!video) return;
  //   el.addEventListener('mouseenter', () => video.play());
  //   el.addEventListener('mouseleave', () => {
  //     video.pause();
  //     video.currentTime = 0;
  //   });
  // });

  // Viewport-play videos in section-chapter
  document.querySelectorAll('.section-chapter__video-placeholder--hover-play').forEach(el => {
    const video = el.querySelector('video');
    if (!video) return;
    ScrollTrigger.create({
      trigger: el,
      start: 'top 85%',
      end: 'bottom 15%',
      onEnter:     () => video.play(),
      onLeave:     () => { video.pause(); video.currentTime = 0; },
      onEnterBack: () => video.play(),
      onLeaveBack: () => { video.pause(); video.currentTime = 0; },
    });
  });

  gsap.set('.h-anim-split, .h-anim-simple', { autoAlpha: 0 });

  ScrollTrigger.batch('.h-anim-split, .h-anim-simple', {
    start: 'top 82%',
    once: true,
    onEnter: (batch) => {
      gsap.to(batch, {
        autoAlpha: 1,
        stagger: 0.12,
        duration: 1.1,
        ease: 'power1.out',
      });
    },
  });

  // Slide-in animation on section-chapter columns
  gsap.utils.toArray('.section-chapter').forEach(section => {
    const reversed     = section.dataset.layout === 'text-right';
    const isResilience = section.classList.contains('section-chapter--resilience');
    const text         = section.querySelector('.section-chapter__text');
    const media        = section.querySelector('.section-chapter__media');

    gsap.set(text, { autoAlpha: 0, x: reversed ? 80 : -80 });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: 'top 72%',
        once: true,
      },
    });

    tl.to(text, { autoAlpha: 1, x: 0, duration: 0.9, ease: 'power2.out' });

    // Two-video stagger animation for resilience (disabled: now single video)
    // if (isResilience) {
    //   const vids = media.querySelectorAll('.section-chapter__video-placeholder, .section-chapter__video-thumb');
    //   gsap.set(vids[0], { autoAlpha: 0, y: -70 });
    //   gsap.set(vids[1], { autoAlpha: 0, y:  70 });
    //   tl.to(vids[0], { autoAlpha: 1, y: 0, duration: 0.9, ease: 'power2.out' }, '<0.1')
    //     .to(vids[1], { autoAlpha: 1, y: 0, duration: 0.9, ease: 'power2.out' }, '<0.15');
    // } else {
    gsap.set(media, { autoAlpha: 0, x: reversed ? -80 : 80 });
    tl.to(media, { autoAlpha: 1, x: 0, duration: 0.9, ease: 'power2.out' }, '<0.1');
    // }
  });

  // Parallax on section-chapter backgrounds
  gsap.utils.toArray('.section-chapter__bg').forEach(bg => {
    gsap.fromTo(bg,
      { y: 120 },
      {
        y: -120,
        ease: 'none',
        scrollTrigger: {
          trigger: bg.closest('.section-chapter'),
          start: 'top bottom',
          end: 'bottom top',
          scrub: true,
        },
      }
    );
  });

  // Mat slider: scroll-hijack horizontal on all screen sizes
  gsap.utils.toArray('.section-mat').forEach(section => {
    const track = section.querySelector('.section-mat__track');
    const slider = section.querySelector('.section-mat__slider');
    const sliderWrap = section.querySelector('.section-mat__slider-wrap');

    const getScrollDist = () => track.scrollWidth - slider.clientWidth;

    ScrollTrigger.create({
      trigger: section,
      start: 'top top',
      end: () => `+=${getScrollDist()}`,
      pin: true,
      pinReparent: true,
      anticipatePin: 1,
      invalidateOnRefresh: true,
      onUpdate: (self) => {
        slider.scrollLeft = self.progress * getScrollDist();
      },
      onLeaveBack: () => {
        slider.scrollLeft = 0;
      },
    });
  });

  // Subtle parallax on each section-poem background (poem + stories)
  gsap.utils.toArray('.section-poem').forEach(section => {
    const bg = section.querySelector('.section-poem__parallax-bg');
    if (!bg) return;
    gsap.fromTo(bg,
      { y: 120 },
      {
        y: -120,
        ease: 'none',
        scrollTrigger: {
          trigger: section,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true,
        },
      }
    );
  });
});
